export const CREATE_POINT_OF_CONTACT = 'api/points-of-contact/create/';
export const GET_POINT_OF_CONTACTS = 'api/points-of-contact/get';
export const GET_POINT_OF_CONTACT_BY_UUID = 'api/points-of-contact/{uuid}/';
export const UPDATE_POINT_OF_CONTACT = 'api/points-of-contact/{uuid}/update/';
export const DELETE_POINT_OF_CONTACT = 'api/points-of-contact/{uuid}/delete/';

